import { ReviewTalentsCVAnalysisUI } from 'features'

const ReviewTalentsCVAnalysis = () => {
  return (
    <div>
      <ReviewTalentsCVAnalysisUI/>
    </div>
  )
}

export { ReviewTalentsCVAnalysis }
